import type { RouteRecordRaw } from 'vue-router'

export const StoryRoutes: RouteRecordRaw[] = [
  {
    path: '/stories',
    component: () => import('@/layouts/dashboard-layout/index.vue'),
    meta: { requiresAuth: true },
    children: [
      {
        path: '',
        name: 'stories-library',
        component: () => import('@/views/stories/index.vue'),
        meta: { breadcrumb: [{ text: 'داستان‌های آموزشی' }] }
      },
      {
        path: ':storyId',
        name: 'story-reader',
        component: () => import('@/views/stories/reader.vue'),
        meta: {
          breadcrumb: [
            { text: 'داستان‌های آموزشی', to: '/stories' },
            { text: 'مطالعه داستان' }
          ]
        }
      }
    ]
  }
]
